  <!-- report tab table html -->
  <div class="reportlist">
    <div class="list-heading d-flex">
      <!-- <span class="label-name">S.No.</span> -->
      <span class="label-name">Date</span>
      <span class="label-name company center">Company Name</span>
      <span class="label-name center">Website</span>
      <span class="label-name cin center">CIN</span>
      <span class="label-name center">Status</span>
      <!-- <span class="label-name center">Amount</span> -->
    </div>

    <div class="list-content">
      <div class="list-row-wrap" *ngFor="let myRequest of myRequestList, let i = index">
        <div class="list-row d-flex">
          <!-- <span class="number" style="width: 225px;">{{i+1}}</span> -->
          <span class="date">{{myRequest?.createdAt| date : "mediumDate" }}</span>
          <span class="name center">{{myRequest?.company_name}}</span>
          <span class="weblink center">{{myRequest?.website}}</span>
          <span class="cin center"> {{myRequest?.cin ===''?'-':myRequest?.cin}}</span>
          <span class="status center">{{myRequest?.status}}</span>
          <!-- <span class="amount center">{{myRequest?.payment_status}}</span> -->
        </div>
      </div>
    </div>
  </div>
